import { MenuItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { EMPTY_STATE_TEXT } from "../../AssetsFilterTags.constants";

interface EmptySearchStateProps {
  searchText: string;
  hasResults: boolean;
}

export default function EmptySearchState({
  searchText,
  hasResults,
}: EmptySearchStateProps) {
  if (!searchText || hasResults) return null;

  return (
    <MenuItem disabled className="py-2 justify-center">
      <ListItemText
        primary={EMPTY_STATE_TEXT}
        slotProps={{
          primary: {
            className: "text-center text-text-secondary italic",
          },
        }}
      />
    </MenuItem>
  );
}
